import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PrismicRichText } from '@prismicio/react';
import { FC } from 'react';
import { ArrowRightIcon } from '@/assets';
import { HeroCtaWithLogosSliceWithStats } from '../../../../prismicio-types';

interface HeroCtaWithLogosSliceWithStatsProps {
  slice: HeroCtaWithLogosSliceWithStats;
}

const WithStats: FC<HeroCtaWithLogosSliceWithStatsProps> = (props) => {
  const { buttons, title, logo } = props.slice.primary;

  return (
    <div className="relative z-10 container mx-auto flex flex-col items-center text-center gap-8">
      <div className="container mx-auto px-10 py-20 flex flex-col items-center text-center">
        <PrismicNextImage
          field={logo}
          className="w-[160px] object-contain mb-6"
          alt=""
        />
        <h2 className="text-white font-inter font-extrabold text-[56px] leading-[120%]">
          <PrismicRichText field={title} />
        </h2>
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        {buttons
          ?.filter(
            (item) =>
              item.button_link &&
              item.button_link.link_type !== 'Any' &&
              item.button_text,
          )
          .map((item, index) => (
            <PrismicNextLink
              key={index}
              field={item.button_link}
              className={index === 0 ? 'secondary-button' : 'tertiary-button'}
            >
              <ArrowRightIcon className="arrow-icon" />
              {item.button_text}
            </PrismicNextLink>
          ))}
      </div>
    </div>
  );
};

export default WithStats;
